import { createTheme, defaultTheme } from '@presov.sk/presov-ui-react';

/**
 * Téma appky je téma knižnice; jediná odchýlka je krok modrej.
 *
 * V knižnici nesie `blue.main` manuálový hex `#337CA3`. Na plochách stavu
 * „V riešení" (guličky na mape, bunka štatistiky, tint štítku v administrácii)
 * čítal príliš zašedlo, preto je škála posunutá o krok vyššie: `main` má
 * svetlejší krok manuálu `#4598C4` a `#337CA3` sa presunulo na `dark`, kde ho
 * berie hover a text. Z manuálu tak neodchádzame, len sa v ňom stojí o schod
 * vyššie.
 *
 * **`info` sa neposúva, hoci je v knižnici zapísané tým istým hexom.**
 * `#4598C4` má na bielej kontrast 3,2:1 - dosť na guličku, rám a plochu, málo
 * na text - a `info` nesie práve text: odkazy v hlasovaniach a v detaile
 * transakcie (`info.main`) a 12px štítok `StatusChip`-u (`info.dark` na
 * `info.surface`, dnes 6,0:1). Posun by ich stiahol pod AA, takže štítok
 * „V riešení" ostáva tmavší než gulička na mape - je to rovnaká rodina, iný
 * krok, nie iná farba.
 *
 * Keby sa to malo raz presťahovať do `@presov.sk/presov-ui-react`, sťahuje sa
 * `blue` aj s touto podmienkou, nie celá rodina naraz.
 */
const theme = createTheme({
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    blue: {
      light: '#6CAED0',
      main: '#4598C4', // svetlejší krok modrej z manuálu
      dark: '#337CA3', // modrá z manuálu
      extraDark: '#286180',
      surface: '#EAF3F8',
      contrastText: '#FFFFFF',
    },
  },
});

export default theme;
